const localization = {
  dashboardPage: {
    heading: "Partner Portal",
  },
  authPage: {
    label: "Partners",
    label_single: "Partner",
  },
  sharelinkPage: {
    text: "affiliate links",
    text_single: "affiliate link",
    label: "Affiliate Links",
    label_single: "Affiliate Link",
    heading: "Partner Affiliate Links",
    heading_single: "Partner Affiliate Link",
    addNewButton: "Add New Affiliate Link",
    agentLabel: "Partner",
  },
  upgradePage: {
    label: "Partners",
    label_single: "Partner",
    text: "partners",
    text_single: "partner",
  },
  forgotPasswordPage: {
    label: "Partners",
    label_single: "Partner",
  },
  clientRegistrationPage: {
    label: "Partners",
    label_single: "Partner",
    initial_description:
      "This portal provides you access to {{company_name}} service contracts, rates, reports, and product marketing resources you need to establish services. Please visit the main site for other {{company_name}} Business Units.",
    description: "Enter your details to login in to our system.",
    post_registration_description:
      "Please verify your email address by clicking the link sent to your inbox. If you do not see the email, check your spam or junk folder, or use the 'Resend' option to request a new verification email.",
  },
  agentRegistrationPage: {
    label: "Sign-In - Internal",
    description: "Enter your details to login in to our system.",
  },
  // Add more pages as needed
};

export default localization;
